module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQBAMAAAACH4lsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTB4jJx8jKR4jKB8iKR4iKSAgKB8jKSAjJh4iKSAgKh4jKR8iKR8jKWPBVJkAAAANdFJOUwBe70DfcCCzMIAQn8+LJAKdAAAAaklEQVQI12NgQAJc093DICyhu3cvBYAYjHeB4DKIxXL30qG7V0As27tubL53G4As2bsBDLF3BcCsCQx7wSzbu4rMuncNgKxFIL2XQDo4QazbYCt8gSw3Bogxd8GGgC25CHVC+3EDZBcxAAC/Niu9hDPjhQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dw.png
// module id = avan
// module chunks = 1